import { render, staticRenderFns } from "./FamilyHistoryContinued.vue?vue&type=template&id=553c6910"
import script from "./FamilyHistoryContinued.vue?vue&type=script&lang=js"
export * from "./FamilyHistoryContinued.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports